import React from 'react';
import { TableRow } from '@material-ui/core';
import Seo from './seo';

function Baixa({ baixa, setBaixa }) {
  return (
    <>
      <TableRow>
        <Seo
          etapas="Mapeamento"
          status={baixa.mapeamento_status}
          setStatus={(data) =>
            setBaixa((prev) => ({ ...prev, mapeamento_status: data }))
          }
          encerramento={baixa.mapeamento_encerramento}
          setEncerramento={(data) =>
            setBaixa((prev) => ({ ...prev, mapeamento_encerramento: data }))
          }
          observacao={baixa.mapeamento_observacao}
          setObservacao={(data) =>
            setBaixa((prev) => ({ ...prev, mapeamento_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Elaboração Do Distrato/Alteração"
          status={baixa.distrato_status}
          setStatus={(data) =>
            setBaixa((prev) => ({ ...prev, distrato_status: data }))
          }
          encerramento={baixa.distrato_encerramento}
          setEncerramento={(data) =>
            setBaixa((prev) => ({ ...prev, distrato_encerramento: data }))
          }
          observacao={baixa.distrato_observacao}
          setObservacao={(data) =>
            setBaixa((prev) => ({ ...prev, distrato_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Certificado Bird ID"
          status={baixa.certificado_status}
          setStatus={(data) =>
            setBaixa((prev) => ({ ...prev, certificado_status: data }))
          }
          encerramento={baixa.certificado_encerramento}
          setEncerramento={(data) =>
            setBaixa((prev) => ({ ...prev, certificado_encerramento: data }))
          }
          observacao={baixa.certificado_observacao}
          setObservacao={(data) =>
            setBaixa((prev) => ({ ...prev, certificado_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Baixa dos Atos Necessários Perante A Receita Federal do Brasil"
          status={baixa.baixa_federal_status}
          setStatus={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_federal_status: data }))
          }
          encerramento={baixa.baixa_federal_encerramento}
          setEncerramento={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_federal_encerramento: data }))
          }
          observacao={baixa.baixa_federal_observacao}
          setObservacao={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_federal_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Baixa Perante a Prefeitura Municipal"
          status={baixa.baixa_municipal_status}
          setStatus={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_municipal_status: data }))
          }
          encerramento={baixa.baixa_municipal_encerramento}
          setEncerramento={(data) =>
            setBaixa((prev) => ({
              ...prev,
              baixa_municipal_encerramento: data,
            }))
          }
          observacao={baixa.baixa_municipal_observacao}
          setObservacao={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_municipal_observacao: data }))
          }
        />
      </TableRow>
      <TableRow>
        <Seo
          etapas="Baixa dos Atos Necessários Perante a Junta Comercial"
          status={baixa.baixa_junta_status}
          setStatus={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_junta_status: data }))
          }
          encerramento={baixa.baixa_junta_encerramento}
          setEncerramento={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_junta_encerramento: data }))
          }
          observacao={baixa.baixa_junta_observacao}
          setObservacao={(data) =>
            setBaixa((prev) => ({ ...prev, baixa_junta_observacao: data }))
          }
        />
      </TableRow>
    </>
  );
}

export default Baixa;
